<!--  -->
<template>
  <div class="join-us-box">
    <j-title :chineseTitle="title.chinese" :enTitle="title.english"></j-title>
    <div class="content-wrapper">
      <!-- <j-head :title="headTitle"></j-head> -->
      <table>
        <tr>
          <th v-for="(item,index) in titleInfo">{{item}}</th>
        </tr>
        <tr v-for="(itemSub, indexSub) in dataInfo">
            <td>{{itemSub.jobTitle}}</td>
            <td>{{itemSub.workYears}}</td>
            <td>{{itemSub.salaryRange}}</td>
            <td>{{itemSub.lastOnlineTime}}</td>
            <td><span class="check-wrapper" @click="toRecruitContent(itemSub.owRecruitmentInfoId
)">{{check}}</span></td>
        </tr>
     </table>
    </div>
    <div class="paging">
      <pagination :pageInfo="pageInfo" @change="pagechange" ></pagination>
    </div>
  </div>
</template>

<script>
import jTitle from '../../../components/header/title'
import jHead from '../../../components/header/head'
import pagination from '../../../components/pagination/pagination'
import http from '../../../api/http.js'
import apiUrl from '../../../api/apiUrl.js'
import util from '../../../api/util.js'

export default {
  name: '',
  data () {
    return {
      title: {
        chinese: '加入我们',
        english: 'JOIN US'
      },
      headTitle: '热招职位',
      titleInfo: ['职位名称', '工作经验', '薪资', '发布时间', '查看详情' ],
      dataInfo: [],
      check: '查看',
      pageInfo:{
        total:1,  // 记录总条数   默认空，如果小于pageNum则组件不显示   
        current:1,  // 当前页数，   默认为1                             
        pagenum:5 , // 每页显示条数,默认10                              
        pagegroup:5,    // 分页条数     默认为5，需传入奇数            
        skin:'#FBABC7'  // 选中页码的颜色主题 默认为'#16a086'  
      },
    }
  },

  props: [],

  watch: {},

  components: {
    jTitle,
    jHead,
    pagination
  },

  computed: {},

  created () {
    this.pagechange(1);
  },

  methods: {
    toRecruitContent(id) {
      this.$router.push({ name: 'JobPage', query: {jobId: id} });
    },
    pagechange(current) {
      this.fetchListInfo( current, this.pageInfo.pagenum)
    },  
    fetchListInfo(pageNum, pageSize) {
      http.get(apiUrl.recruitListInfo + '/' + pageNum + '/' + pageSize)
        .then(response => {
          console.log(response);
          const data = response.data;
          if (response.code == 0) {
            for (let i = 0; i < data.list.length; i++) {
              data.list[i].lastOnlineTime = util.formatTime(data.list[i].lastOnlineTime, '', '/');
            }
            this.pageInfo.total = data.total;
            this.dataInfo = data.list;
          }
        })
    }
  }
}

</script>
<style lang='scss' scoped>
.join-us-box {
  width: 100%;
  background: rgb(255,248,250);
  padding: 50px 350px 135px 350px;
  min-height: 61vh;
  box-sizing: border-box;
  font-size: 30px;
  position: relative;
  .content-wrapper{
    margin-top: 50px;
    table {
      font-size: 20px;
      line-height: 28px;
      text-align: center;
      margin-top: 30px;
    }
    
    table tr th {
      width: 244px;
      height: 70px;
      background: #FF789E;
      color: #fff;
    }
    table tr td {
      width: 244px;
      height: 70px;
      color: #666666;
      .check-wrapper {color: #FF789E; cursor: pointer; text-decoration: none; border-bottom: 1px solid;}
      .check-wrapper:hover {color:#FD4E7F;}
    }
    table tr:nth-child(odd) {background: rgb(255,248,250);}
    table tr:nth-child(even) { background: #fff;}
  }
  .paging {
    position: absolute;
    right: 350px;
    bottom: 50px;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/index/components/joinUs.vue